"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.delete.confirm.title': 'Usuń Krok',
    'step.delete.confirm.message': 'Czy na pewno chcesz usunąć ten krok?',
};
